import { IAchAccountResponse } from '../../../types/accounting/response/IEscrowExpectedAchPullDepositResponse';
import { IAchAccountData } from '../../../types/order/escrow/IAchAccountData';
import { ICreateAchAccountData } from '../../../API/accounting/createAchAccountAsync';

export function instanceOfIAchAccount(object?: IAchAccountData | ICreateAchAccountData): object is IAchAccountResponse {
  return !!object && 'id' in object;
}
// this typeguard looks for ICreateAchAccountRequest (as opposed to IAchAccountData).
export function instanceOfICreateAchAccountData(
  object?: IAchAccountData | ICreateAchAccountData
): object is ICreateAchAccountData {
  return !!object && !('id' in object);
}
